
import React, { Component } from 'react'
import { findDOMNode } from 'react-dom'
import classNames from 'classnames'
import './InlineEdit.css'

var ESCAPE_KEY = 27;
var ENTER_KEY = 13;

class InlineEdit extends Component {
  constructor(props) {
    super(props);
    this.state = { editText: '', editing: false }
  }

  _handleBlur = (event) => {
    this.setState({editing: false, editText: ''})
  }

  _handleLabelClick = (e) => {
    if (!this.props.showEditButton) {
      this.setState({editing: true, editText: this.props.value})
    } else {
      this.props.onClick && this.props.onClick(e)
    }
  }

  _handleEditButtonClick = () => {
    this.setState({editing: true, editText: this.props.value})
  }

  _handleKeyDown = (event) => {
    if (event.which === ESCAPE_KEY) {
      this.setState({editing: false, editText: ''})
      event.preventDefault()
      event.stopPropagation()
    } else if (event.which === ENTER_KEY) {
      this.props.onSubmit && this.props.onSubmit(this.state.editText);
      this.setState({editing: false, editText: ''})
    }
  }

  _handleChange = (event) => {
    if (this.state.editing) {
      this.setState({editText: event.target.value})
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.editing === false && this.state.editing === true && this.refs.editField) {
      findDOMNode(this.refs.editField).focus()
      findDOMNode(this.refs.editField).select()
    }
  }

  stopEditing() {
    this.setState({editing: false, editText: ''})
  }

  renderInput() {
    const { editText } = this.state

      return (
        <input
          type="text"
          ref="editField"
          className="inline-edit__input"
          value={editText || ''}
          onBlur={this._handleBlur}
          onChange={this._handleChange}
          onKeyDown={this._handleKeyDown}/>
      )
  }

  render() {
    const { value, labelTitle, showEditButton, valueFormatter } = this.props;
    const { editing } = this.state;

    const val = valueFormatter ? valueFormatter(value) : value;

    return (
      <div className={classNames('inline-edit', this.props.className)}>
        {editing
          ? this.renderInput()
          : <span>
              <label className="inline-edit__label" onClick={this._handleLabelClick}>{val || labelTitle}</label>
              { showEditButton && <span onClick={this._handleEditButtonClick} className='icon-pencil inline-edit__edit-button'></span> }
            </span>
        }
      </div>
    );
  }
}

export default InlineEdit



// WEBPACK FOOTER //
// ./src/components/Generic/InlineEdit.js